import gql from 'graphql-tag';

const UPDATE_SEGMENTOBSERVATION = gql`
  mutation updateSegmentsWithObservations($ids: String!) {
    updateSegmentsWithObservations(ids: $ids)
  }
`;

export default UPDATE_SEGMENTOBSERVATION;
